module.exports = __webpack_public_path__ + "img/gift3.01de9f71.png";